module.exports = __webpack_public_path__ + "media/assets/logo-4cd6b02c2315875bb9216a520b1b3621.png";